/* tslint:disable */
/* eslint-disable */
/**
 * Public Track API
 * Public Track APIs provide customers access to their SPiDRs, Security Focuses and SPiDR Blueprints
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const NIST2Category = {
    GvOcOrganizationalContext: 'GV.OC: Organizational Context',
    GvRmRiskManagementStrategy: 'GV.RM: Risk Management Strategy',
    GvRrRolesResponsibilitiesAndAuthorities: 'GV.RR: Roles, Responsibilities, and Authorities',
    GvPoPolicy: 'GV.PO: Policy',
    GvOvOversight: 'GV.OV: Oversight',
    GvScCybersecuritySupplyChainRiskManagement: 'GV.SC: Cybersecurity Supply Chain Risk Management',
    IdAmAssetManagement: 'ID.AM: Asset Management',
    IdRaRiskAssessment: 'ID.RA: Risk Assessment',
    IdImImprovement: 'ID.IM: Improvement',
    PrAaIdentityManagementAuthenticationAndAccessControl: 'PR.AA: Identity Management, Authentication, and Access Control',
    PrAtAwarenessAndTraining: 'PR.AT: Awareness and Training',
    PrDsDataSecurity: 'PR.DS: Data Security',
    PrPsPlatformSecurity: 'PR.PS: Platform Security',
    PrIrTechnologyInfrastructureResilience: 'PR.IR: Technology Infrastructure Resilience',
    DeCmContinuousMonitoring: 'DE.CM: Continuous Monitoring',
    DeAeAdverseEventAnalysis: 'DE.AE: Adverse Event Analysis',
    RsMaIncidentManagement: 'RS.MA: Incident Management',
    RsAnIncidentAnalysis: 'RS.AN: Incident Analysis',
    RsCoIncidentResponseReportingAndCommunication: 'RS.CO: Incident Response Reporting and Communication',
    RsMiIncidentMitigation: 'RS.MI: Incident Mitigation',
    RcRpIncidentRecoveryPlanExecution: 'RC.RP: Incident Recovery Plan Execution',
    RcCoIncidentRecoveryCommunication: 'RC.CO: Incident Recovery Communication'
} as const;
export type NIST2Category = typeof NIST2Category[keyof typeof NIST2Category];


export function NIST2CategoryFromJSON(json: any): NIST2Category {
    return NIST2CategoryFromJSONTyped(json, false);
}

export function NIST2CategoryFromJSONTyped(json: any, ignoreDiscriminator: boolean): NIST2Category {
    return json as NIST2Category;
}

export function NIST2CategoryToJSON(value?: NIST2Category | null): any {
    return value as any;
}

